import axios from 'axios';
import { vendorUrlRegexPath, withPimURL } from 'src/helpers/service';

export interface IBulkCancelFlashDiscountBody {
  flashDiscountIds: number[];
}

export interface IBulkCancelFlashDiscountResponse {
  status: boolean;
}

export const bulkCancelFlashDiscountMutationKey = () => {
  return ['bulk-cancel-flash-discount'];
};

export const bulkCancelFlashDiscount = async (body: IBulkCancelFlashDiscountBody) => {
  return axios.post<IBulkCancelFlashDiscountResponse>(withPimURL(vendorUrlRegexPath('/flash-discount/:vendorId/bulk-cancel')), body).then((res) => res.data);
};
